// Shared SEO text helpers so page meta and the /admin/seo registry stay in sync.
export const clamp = (s, max = 160) => {
  if (!s || s.length <= max) return s || "";
  const cut = s.slice(0, max - 1);
  const space = cut.lastIndexOf(" ");
  return (space > 40 ? cut.slice(0, space) : cut).trim() + "…";
};

const TYPE_LABEL = {
  yoga: "Yoga Retreat",
  wellness: "Wellness Escape",
  adventure: "Adventure Retreat",
  travel: "Travel Escape",
};

export const escapeTitle = (d) => `${d.title}, ${d.country} — ${TYPE_LABEL[d.category] || "Escape"} | YogaToYacht`;

export const escapeDescription = (d) => {
  const base = (d.blurb || "").trim();
  const suffix = " — curated retreats on YogaToYacht.";
  if ((base + suffix).length <= 160) return base + suffix;
  return clamp(base, 160);
};
